export const GROUP_NUMBER = {
	Brookshire_Brothers: 220,
	Intercity_Investment: 188,
	Panhandle_First_Bank: 225,
	Progressive_Laboratories: 300,
	Test_Group: 999
};
